import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'orderBy',
  standalone: false
})
export class ArraySortPipe implements PipeTransform {
  transform<T = any>(array: T[], fields: string | string[], reverse: boolean = false): T[] {
    if (!Array.isArray(array) || !fields) {
      return array as any;
    }

    const keys: string[] = Array.isArray(fields)
      ? fields
      : String(fields)
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);

    if (keys.length === 0) {
      return array;
    }

    const cmp = (a: any, b: any): number => {
      for (const k of keys) {
        const av = a?.[k];
        const bv = b?.[k];

        const aU = av === undefined || av === null;
        const bU = bv === undefined || bv === null;
        if (aU && bU) {
          continue;
        }
        if (aU) {
          return reverse ? 1 : -1;
        }
        if (bU) {
          return reverse ? -1 : 1;
        }

        const aStr = typeof av === 'string' ? av.toLowerCase() : av;
        const bStr = typeof bv === 'string' ? bv.toLowerCase() : bv;

        if (aStr < bStr) {
          return reverse ? 1 : -1;
        }
        if (aStr > bStr) {
          return reverse ? -1 : 1;
        }
      }
      return 0;
    };

    return array.sort(cmp);
  }
}
